import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { TableColumn } from '@app/components/common/table';
import { Level } from '@app/api/models/structure';


export const useColumns = ({ onEdit }: { 
  onEdit: (item: Level) => void;
}): TableColumn<Level>[] => {
  return [
    {
      name: 'name',
      label: 'Наименование',
      options: {
        filter: {
          name: 'name',
          type: 'text',
        },
        sort: false,
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id, { rowData }) => {
          return (
            <Flex gap={2}>
              <IconButton name="edit" onClick={() => onEdit(rowData)} aria-label="edit" size='sm'>
                <MdEdit />
              </IconButton>
            </Flex>
          );
        },
      },
    },
    {
      name: 'is_active',
      label: 'Активность',
      options: {
        hidden: true,
        filter: {
          name: 'is_active',
          type: 'boolean',
        },
        sort: false,
      },
    }
  ];
};